import React, { useEffect } from "react";
import SubjectDetailsCard from "../components/subjects/subject-details-card/SubjectDetailsCard";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  archiveSubject,
  archiveSubjectClear,
  getMyOrganization,
  getSubjectList,
  getSubjectListRequest,
  transferSubject,
  transferSubjectClear,
  unarchiveSubject,
  unarchiveSubjectClear,
  useDynamicSelector } from
"@src/redux";
import { Col, Empty, Row, Spin } from "antd";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const Subject: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { result: getSubjects, loading } = useSelector(getSubjectList);
  const { result: archiveResult } = useSelector(archiveSubject);
  const { result: unArchiveResult } = useSelector(unarchiveSubject);
  const { result: transferSubjectResult, loading: transferSubjectLoading } =
  useSelector(transferSubject);
  const { result: getMyOrg } = useSelector(getMyOrganization);
  const { filter } = useDynamicSelector("subject_filter");

  const { t } = useTranslation();

  useEffect(() => {
    if (archiveResult?.status === "success") {
      dispatch(archiveSubjectClear());
      toast.success(t("Archive updated successfully."));
      dispatch(
        getSubjectListRequest({
          filter: { ...filter },
          pagination: { pageLimit: 30, pageNumber: 1 }
        })
      );
    } else if (archiveResult?.error?.message) {
      toast.error(archiveResult.error.message);
      dispatch(archiveSubjectClear());
    } else if (unArchiveResult?.status === "success") {
      dispatch(unarchiveSubjectClear());
      toast.success(t("Un Archive updated successfully."));
      dispatch(
        getSubjectListRequest({
          filter: { ...filter },
          pagination: { pageLimit: 30, pageNumber: 1 }
        })
      );
    } else if (unArchiveResult?.error?.message) {
      toast.error(unArchiveResult.error.message);
      dispatch(unarchiveSubjectClear());
    } else if (transferSubjectResult?.status === "success") {
      toast.success(t("subject_transfer_successfully"));
      dispatch(transferSubjectClear());
      dispatch(
        getSubjectListRequest({
          filter: { ...filter },
          pagination: { pageLimit: 30, pageNumber: 1 }
        })
      );
    } else if (transferSubjectResult?.error?.message) {
      toast.error(transferSubjectResult?.error?.message);
      dispatch(transferSubjectClear());
    }
  }, [archiveResult?.status, unArchiveResult, transferSubjectResult]);

  return (
    <>
      <Row justify={"center"}>
        {loading && <Spin size="large" />}
        {!loading &&
        getSubjects?.items &&
        getSubjects?.items?.length === 0 &&
        <Empty
          description={`${
          getMyOrg?.rootOrganization?.subjectLabel || ""} not found.`} />}

        
      </Row>
      <div className="subject-list-container">
        {getSubjects?.items &&
        getSubjects?.items?.map((subject, index) =>
        <SubjectDetailsCard key={subject.id} subject={subject} />
        )}
      </div>
    </>);

};

export default Subject;